export default __webpack_public_path__ + "static/media/lotus-bold.0586d500.svg";